import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-template-areas:
      'intro pic'
      'skills pic';
    align-items: start;
    grid-gap: 50px;

    @media (max-width: 600px) {
      display: flex;
      flex-direction: column;
    }
  }
`;
const StyledIntro = styled.div`
  grid-area: intro;
`;

const StyledPic = styled.div`
  grid-area: pic;
  position: relative;
  max-width: 300px;

  @media (max-width: 600px) {
    margin: 40px auto;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: transparent;
    border: 1px solid var(--lightest-navy);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: normal;
      filter: grayscale(10%) contrast(1.02);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: transparent;
      mix-blend-mode: normal;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading section-heading-mono">About Me</h2>

      <div className="inner">
        <StyledIntro>
          <p>
            It’s fun to build something fast, but my favorite part of engineering is making sure it
            survives the real world. Whether it's a brand-new app or a heavy-duty enterprise system,
            I'm passionate about writing clean, dependable code.
          </p>
          <p>
            Since the summer 2026, I've joined{' '}
            <a href="https://www.cae.com/" target="_blank" rel="noopener noreferrer">
              CAE USA
            </a>
            , where I have been developing my skills as a software engineer by contributing to
            real-world projects and collaborating with experienced teams.
          </p>

          {/* <p>
            Most recently, I’m currently interning at{' '}
            <a href="https://www.cae.com/" target="_blank" rel="noopener noreferrer">
              CAE USA
            </a>
            , where I've been gaining hands-on experience in real-world engineering environments. My
            main focus has been learning new technologies, deepening my understanding of systems and
            software, and building projects that continue to challenge me and help me grow as an
            engineer.
          </p> */}

          {/*  <p>
            I also recently{' '}
            <a href="https://www.newline.co/courses/build-a-spotify-connected-app">
              launched a course
            </a>{' '}
            that covers everything you need to build a web app with the Spotify API using Node
            &amp; React.
          </p> */}
        </StyledIntro>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.JPG"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>

        {/* <StyledSkills>
          <p>Here are a few technologies that I’ve been working with recently:</p>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledSkills> */}
      </div>
    </StyledAboutSection>
  );
};

export default About;
